<template src="../templates/normal_fcont_203.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'
import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import PrintButton from '../components/PrintButton'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadPhotoPlus from '../components/AppDownloadPhotoPlus'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  data() {
    return {
      articleId: '203',
      app_root: process.env.VUE_APP_ROOT
    };
  },
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,
    PrintButton,InfoMachineTranslation,AppDownloadCreative,AppDownloadPhotoPlus
  },
  methods: {
    clickInternalLink: function (linkName) {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "internal_link",
        "custom_parameter2": linkName
      })
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['203-1'],
      meta: [
        { name: 'description', content: this.$store.state.messages.messages['203-3']}
      ]
    };
  }
  
};
</script>
<style scoped>
</style>

